module.exports = __webpack_public_path__ + "static/media/pic3@2x.0a21312e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic3@2x.png
// module id = 1396
// module chunks = 0